// src/App.tsx

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppRoutes from 'routes/AppRoutes';
 

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* <React.Suspense fallback={<div>در حال بارگذاری...</div>}> */}
          <AppRoutes />
        {/* </React.Suspense> */}
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
